import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { threatRegistersApi, templateApi } from '../services/api';
import { RegisterManagementPage } from './RegisterManagementPage';
import type { Template } from '../types/models';

export const ThreatRegistersPage: React.FC = () => {
  // Fetch templates dynamically from the API
  const { data: templatesData } = useQuery({
    queryKey: ['templates', 'threat'],
    queryFn: () => templateApi.list('threat'),
  });

  // Convert templates to dropdown options (only show active templates)
  const templates = templatesData
    ?.filter((t: Template) => t.isActive)
    .map((t: Template) => ({
      value: t.templateName,
      label: t.displayName,
    })) || [];

  // Determine default template (first active template, or fallback)
  const defaultTemplate = templates.length > 0 ? templates[0].value : 'comprehensive';

  return (
    <RegisterManagementPage
      title="Threat Registers"
      iconClass="ri-folder-line"
      queryKey="threatRegisters"
      api={threatRegistersApi}
      includeDepartments
      templates={templates}
      defaultTemplate={defaultTemplate}
      listPath="/threats"
      configPath="/threat-config"
      applyTemplateKind="threat"
      allowBlankTemplate
      countField="threatCount"
      countLabel="Threats"
      allowForceDelete
    />
  );
};
